var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "episode"
  }, [_c('section', {
    staticClass: "section-center row"
  }, [_c('header', {
    staticClass: "col"
  }, [_c('img', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "src": _vm.episode.artworkUrl,
      "alt": 'Show #' + _vm.number,
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v("Show #" + _vm._s(_vm.number) + "\n            "), (_vm.episode.broadcastedAt) ? _c('small', [_vm._v(" - " + _vm._s(_vm.episodeDate))]) : _vm._e()])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), (_vm.tracks.length) ? _c('section', {
    staticClass: "section-center row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-responsive",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('tbody', [_vm._l((_vm.tracks), function(track, index) {
    return [(track.playlistId !== (_vm.tracks[index - 1] && _vm.tracks[index - 1].playlistId)) ? _c('tr', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Playlist',
          params: {
            id: track.playlistId
          }
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.playlistForTrack(track).name) + "\n                ")])], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v("\n                " + _vm._s(track.number) + "\n                "), _c('small', [_c('a', {
      attrs: {
        "href": _vm.audioAtTime(track.startAt),
        "target": "_blank"
      }
    }, [_vm._v("~" + _vm._s(_vm.duration(track.startAt)))])])]), _vm._v(" "), _c('td', [_c('track-row', {
      attrs: {
        "track-id": track.trackId
      }
    })], 1)])]
  })], 2)])])]) : _c('section', {
    staticClass: "section-center card bg-danger mb-3 text-white"
  }, [_vm._m(2)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col text-right"
  }, [_c('a', {
    staticClass: "mdl-button",
    attrs: {
      "href": ""
    }
  }, [_vm._v("Listen on SoundCloud")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h4', [_vm._v("Tracks")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("Oh no")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v("The tracklist for this show has not been officially published by the Soulection team yet.")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56632c0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Episode.vue
// module id = X3yh
// module chunks = 1